<script>
import AppHeader from '@comp/AppHeader'

export default {
  name: 'App',

  components: {
    AppHeader
  },

  created() {
    this.Loading.yes = !this.$auth.ready()
  },

  watch: {
    '$auth.watch.loaded': function() {
      console.log('loaded')
      this.Loading.yes = false
    },

    '$auth.watch.authenticated': function(value) {
      console.log('authenticated')
      if (value) {
        document.documentElement.classList.add('has-navbar-fixed-top')
      } else {
        document.documentElement.classList.remove('has-navbar-fixed-top')
      }
    }
  }
}
</script>

<template>
  <div id="app">
    <div class="loading" v-if="Loading.yes">loading</div>

    <app-header v-if="$auth.check()"/>

    <router-view v-if="$auth.ready()" />

    <div class="alerts" v-show="Alerts.length">
      <div class="notification"
        v-for="alert in Alerts"
        :key="alert.id"
        :class="'is-' + alert.type">{{ alert.trans.text }}</div>
    </div>
  </div>
</template>

<style>
html,
body {
  background: #222135;
}

.has-navbar-fixed-top #app {
  padding: 20px 0;
}

.alerts {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  max-height: 100%;
}

.alerts div {
  display: block;
  max-width: 640px;
  margin: 10px auto;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 5em;
  background: rgba(0, 0, 0, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/App.vue